<app-top-nav
  *ngIf="
    (authService.loggedIn$ | async) &&
    layout.showLayout &&
    navReady
  "
  [sidebarOpen]="layout.isSidebarOpen"
  (toggleSidebar)="toggleSidebar()"
>
</app-top-nav>

<app-side-nav
  class="side-nav"
  [style.display]="sideNavVisible ? '' : 'none'"
>
</app-side-nav>

<div
  *ngIf="
    layout.showLayout &&
    layout.isMobileView &&
    layout.isSidebarOpen
  "
  class="sidebar-overlay"
  (click)="closeSidebar()"
>
</div>

<div
  class="main-content"
  [class.expanded]="
    !layout.isSidebarOpen ||
    layout.isMobileView ||
    !layout.isSidebarVisible
  "
  [class.public-page]="!layout.showLayout"
>
  <router-outlet></router-outlet>
</div>



<!-- Komudu domain migration notice -->
<div
  *ngIf="showDomainMigrationModal"
  class="komudu-migration-overlay"
>
  <div
    class="komudu-migration-modal"
    role="dialog"
    aria-modal="true"
    aria-labelledby="komudu-migration-title"
    aria-describedby="komudu-migration-description"
  >
    <div class="komudu-migration-icon">
      <i class="bi bi-info-circle"></i>
    </div>

    <h2 id="komudu-migration-title">
      Our Communities Have Moved!
    </h2>

    <p id="komudu-migration-description">
      Our community platform has moved to
      <strong>Komudu</strong>.
    </p>

    <p>
      You've been automatically redirected from
      KontactApp to our new community website.
      Your community and existing information remain unchanged.
    </p>

    <p class="komudu-migration-note">
      Please update your bookmarks to use
      <strong>community-staging.komudu.com</strong>.
    </p>

    <button
      #migrationContinue
      type="button"
      class="btn btn-lite-blue komudu-migration-button"
      (click)="closeDomainMigrationModal()"
    >
      Continue to Community
    </button>
  </div>
</div>
